import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = StyleSheet.create({
    button: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderWidth: 1,
        borderColor: Theme.secondaryButtonBorderColor,
        backgroundColor: Theme.secondaryButtonBackgroundColor,
        borderRadius: 4,
        padding: 20,
        maxWidth: 129
    },
    icon: {
        width: 50,
        height: 50
    },
    heading: {
        paddingTop: 20,
        fontFamily: Theme.regularFont,
        color: Theme.primaryTextColor,
        fontSize: 21,
        lineHeight: 24,
        textAlign: 'center'
    },
    description: {
        fontFamily: Theme.regularFont,
        color: Theme.secondaryTextColor,
        fontSize: 19,
        lineHeight: 24,
        textAlign: 'center'
    }
});

export default baseStyles;
